import React, { useState } from 'react';
import { Button } from '@getro/rombo';
import { Mail } from 'lucide-react';
import PropTypes from 'prop-types';
import { Box, Text } from 'rebass/styled-components';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { SocialOAuthButtons } from '../../../components/molecules/socialOAuthButtons';
import { userSelector } from '../../../redux/selectors';
import { OAuthMessageError } from '../../../components/molecules/oAuthMessageError';

export const SignUp = ({ routePath }) => {
  const [oAuthError, setOAuthError] = useState(null);
  const { email } = useSelector(userSelector) || {};
  const history = useHistory();

  const onClickSignUp = (mode) => {
    history.push(`${routePath}/profile/${mode}`);
  };

  return (
    <>
      <Text fontSize="22px" fontWeight="semibold" color="text.dark">
        Find who you know at these companies
      </Text>
      <Text mt="16px" mb="32px">
        Connect your LinkedIn to easily find warm intros and offer help.
      </Text>
      <Box>
        <Text fontSize="14px" pb="8px" color="text.dark">
          You were invited at{' '}
          <Text as="span" fontWeight="medium">
            {email}
          </Text>
          , use it to sign up.
        </Text>
        <SocialOAuthButtons
          onSuccess={() => {
            setOAuthError(null);
            onClickSignUp('social');
          }}
          onError={(e) => {
            setOAuthError(e);
          }}
        />
        <Button
          mt="8px"
          icon={Mail}
          variant="secondary"
          width="100%"
          sx={{ gap: '16px', justifyContent: 'center' }}
          onClick={() => onClickSignUp('email')}
        >
          Sign up with email
        </Button>

        {!!oAuthError && <OAuthMessageError mt="8px" oAuthError={oAuthError} email={email} />}
      </Box>
    </>
  );
};

SignUp.propTypes = {
  routePath: PropTypes.string.isRequired,
};
